module.exports = {
	"id": "FJ",
	"name": "Fiji",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": 0.010896,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.010896,
			"11": 0.010896,
			"12": 0.02724,
			"13": null,
			"14": null,
			"15": 0.010896,
			"16": null,
			"17": null,
			"18": 0.016344,
			"19": null,
			"20": 0.005448,
			"21": 0.005448,
			"22": null,
			"23": null,
			"24": 0.010896,
			"25": null,
			"26": 0.021792,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.010896,
			"31": 0.032688,
			"32": 0.010896,
			"33": 0.038136,
			"34": 0.02724,
			"35": 0.05448,
			"36": 0.021792,
			"37": null,
			"38": 0.010896,
			"39": 0.021792,
			"40": 0.016344,
			"41": 0.016344,
			"42": 0.016344,
			"43": 0.08172,
			"44": 0.02724,
			"45": 0.070824,
			"46": 0.05448,
			"47": 0.049032,
			"48": 0.049032,
			"49": 1.176768,
			"50": 0.076272,
			"51": 0.288744,
			"52": 0.261504,
			"53": 14.350032,
			"54": 5.605992,
			"55": 0.065376,
			"56": 0.043584,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.016344,
			"4": 0.070824,
			"5": 0.049032,
			"6": 0.038136,
			"7": 0.02724,
			"8": 0.043584,
			"9": 0.010896,
			"10": 0.103512,
			"11": 0.114408,
			"12": 0.087168,
			"13": 0.021792,
			"14": 0.05448,
			"15": 0.059928,
			"16": 0.288744,
			"17": 0.119856,
			"18": null,
			"19": 0.016344,
			"20": 0.043584,
			"21": 0.038136,
			"22": 0.021792,
			"23": 0.021792,
			"24": 0.02724,
			"25": null,
			"26": 0.005448,
			"27": 0.087168,
			"28": 0.021792,
			"29": 0.032688,
			"30": 0.05448,
			"31": 0.059928,
			"32": 0.010896,
			"33": 0.005448,
			"34": 0.02724,
			"35": 0.152544,
			"36": 0.065376,
			"37": 0.02724,
			"38": 0.103512,
			"39": 0.05448,
			"40": 0.070824,
			"41": 0.087168,
			"42": 0.059928,
			"43": 0.555696,
			"44": 0.201576,
			"45": 0.157992,
			"46": 0.098064,
			"47": 1.2258,
			"48": 1.029672,
			"49": 9.119952,
			"50": 0.986088,
			"51": 0.005448,
			"52": null,
			"3.5": null,
			"3.6": 0.010896
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.010896,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.021792,
			"36": 0.010896,
			"37": 0.049032,
			"38": null,
			"39": 0.010896,
			"40": 0.179784,
			"41": 0.02724,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.005448
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.005448,
			"6": 0.010896,
			"7": 0.021792,
			"8": 0.05448,
			"9": 0.08172,
			"10": 0.414048,
			"3.1": null,
			"3.2": null,
			"5.1": 0.02724,
			"6.1": 0.010896,
			"7.1": null,
			"9.1": 0.343224
		},
		"ios_saf": {
			"8": 0,
			"10": 2.48261786678,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0669036788093,
			"8.1-8.4": 0.123601711699,
			"9.0-9.2": 0.0589659542048,
			"9.3": 0.89960878851
		},
		"android": {
			"3": 0,
			"4": 0.10158020155,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0126975251938,
			"4.1": 0.36641429845,
			"4.2-4.3": 0.916035746124,
			"4.4": 2.10053345349,
			"4.4.3-4.4.4": 2.11867277519
		},
		"ie": {
			"6": 0.016372130809,
			"7": 0.0327442616179,
			"8": 1.18970817212,
			"9": 0.431132777969,
			"10": 0.491163924269,
			"11": 4.18035073322,
			"5.5": null
		},
		"op_mob": {
			"0": 0.133699673344,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0037138798151
		},
		"edge": {
			"12": 0.174336,
			"13": 0.43584,
			"14": 0.533904
		},
		"ie_mob": {
			"10": 0.442408478873,
			"11": 1.80123452113
		},
		"bb": {
			"7": 0.01934175,
			"10": null
		},
		"samsung": {
			"0": 6.489726
		},
		"and_uc": {
			"0": 3.545229
		},
		"op_mini": {
			"0": 1.80131244684
		},
		"and_chr": {
			"0": 28.714002
		},
		"and_ff": {
			"0": 0.018204
		}
	},
	"total": 99.18915975
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/FJ.json
 ** module id = 519
 ** module chunks = 0
 **/